import React from 'react';
import classNames from 'classnames';
import type { Transform } from '@dnd-kit/utilities';
import { CSS } from '@dnd-kit/utilities';
import CardContainer from 'src/components/layouts/CardContainer/CardContainer';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import KPINumber, { KPINumberProps } from 'src/components/ui/KPINumber/KPINumber';
import LineChart, { lineChartDemoData } from 'src/components/charts/LineChart/LineChart';
import styles from './LineChartCard.module.scss';

export interface LineChartCardProps {
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  setNodeRef?: (node: HTMLElement | null) => void;
  transform?: Transform | null;
  transition?: string;
  title: string;
  kpi?: KPINumberProps;
  children?: React.ReactNode;
}

const LineChartCard: React.FC<LineChartCardProps> = ({
  attributes,
  listeners,
  setNodeRef,
  transform,
  transition,
  title,
  kpi,
  children,
}) => {
  const style = {
    transform: CSS.Transform.toString(transform || null),
    transition,
    touchAction: 'none',
  };

  return (
    <CardContainer
      className={classNames(styles.root)}
      ref={setNodeRef}
      style={style}
      label={title}
      attributes={attributes}
      listeners={listeners}>
      {kpi && (
        <div className="mb-20">
          <KPINumber {...kpi} />
        </div>
      )}
      <LineChart data={lineChartDemoData} />
      {children}
    </CardContainer>
  );
};

export default LineChartCard;
